import {
  parseBreakpointsInput
} from "../../state/modules/breakpoints";
import {
  configureStore,
  copyElementTree,
  getBreakpoints,
  getElementTreeTranslatableData,
  mergeElementTreeTranslatedData
} from "../../state/react-page";
class RuntimeCore {
  store;
  constructor({ breakpoints }) {
    this.store = configureStore({
      name: "Runtime store",
      preloadedState: null,
      breakpoints: breakpoints ? parseBreakpointsInput(breakpoints) : void 0
    });
  }
  copyElementTree(elementTree, replacementContext) {
    return copyElementTree(this.store.getState(), elementTree, replacementContext);
  }
  getBreakpoints() {
    return getBreakpoints(this.store.getState());
  }
  getTranslatableData(elementTree) {
    return getElementTreeTranslatableData(this.store.getState(), elementTree);
  }
  mergeTranslatedData(elementTree, translatedData) {
    return mergeElementTreeTranslatedData(this.store.getState(), elementTree, translatedData);
  }
}
export {
  RuntimeCore
};
//# sourceMappingURL=runtime-core.js.map